import { render, staticRenderFns } from "./AlertaInstrucaoNormativa.vue?vue&type=template&id=638b5c5f&scoped=true&"
import script from "./AlertaInstrucaoNormativa.vue?vue&type=script&lang=js&"
export * from "./AlertaInstrucaoNormativa.vue?vue&type=script&lang=js&"
import style0 from "./AlertaInstrucaoNormativa.vue?vue&type=style&index=0&id=638b5c5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638b5c5f",
  null
  
)

export default component.exports